/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
 
  let check_license = document.querySelector( '#check-license' );
  let check_license_value = document.querySelector( '#check-license-value' );
  
  let check_delivery = document.querySelector( '#check-delivery' );
  let check_delivery_value = document.querySelector( '#check-delivery-value' );
  
  let add_to_cart = document.querySelector( 'button[data-action="add-to-cart"]' );  
  let restriction_more_info = document.querySelector( '#restriction-more-info' );
  
  let data_required = document.querySelectorAll( '#restriction-more-info input[data-required]' );
  
  function validateRequiredFields() {
    
    let isValid = true;
    
    for ( let item of data_required ) {
     
      if ( item.value === "" ) {
        
        isValid = false;
        break;
      
      }
      
    }
    
    console.log( 'isValid:', isValid );
    
    return isValid;
    
  }
  
  for ( let item of data_required ) {
     
    item.oninput = function( e ) {
      
      if ( ( check_license_value.value == "SI" ) && validateRequiredFields() ) {
        
        add_to_cart.disabled = false;
      
      }
      else {
        
        add_to_cart.disabled = true;
      
      }
      
    }
      
  }
  
  if ( check_license && restriction_more_info ) {
  
    check_license.onchange = function( e ) {

      console.log('**** check_license', e.target.checked);
      
      if ( e.target.checked ) {
        
        check_license_value.value = "SI";        
        add_to_cart.disabled = false;
        
      }
      else {
        
        check_license_value.value = "NO";
        add_to_cart.disabled = true;

      }
      
    }
    
    check_delivery.onchange = function( e ) {

      console.log('**** check_delivery', e.target.checked);
      
      for ( let item of data_required ) item.value = "";
      
      if ( e.target.checked ) {
        
        check_delivery_value.value = "SI";
        
        restriction_more_info.classList.remove( 'hide' );
        
        if ( check_license_value.value === "SI" ) add_to_cart.disabled = true;
        
      }
      else {
        
        check_delivery_value.value = "NO";
        
        restriction_more_info.classList.add( 'hide' );
        
        if ( check_license_value.value === "NO" ) add_to_cart.disabled = true;
        else add_to_cart.disabled = false;

      }
      
    }
  
  }
  
});